import { render, staticRenderFns } from "./VanishingTimer.vue?vue&type=template&id=88c149bc&"
import script from "./VanishingTimer.vue?vue&type=script&lang=js&"
export * from "./VanishingTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports